<template>
    <transition appear name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
import _ from 'lodash';
import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';

export default {
    name: 'offer-generation-index',
    title: 'Offer Generation',
};
</script>

<style scoped>
.table-input {
    max-width: 80px;
    text-align: right;
}

.table-img {
    max-width: 100px;
}

.editable .controls .fa-solid {
    font-size: 18px;
    transition: .2s ease;
}

.editable .controls .fas:hover {
    transform: scale(1.2);
}

.editable .data {
    position: relative;
}

.editable .data:hover {
    background: #f6f6f6;
    cursor: pointer;
}

.editable .data:hover:after {
    font-family: 'FontAwesome';
    content: "\f14b";
    position: absolute;
    right: 4px;
    top: 0;
    color: lightcoral;
    font-size: 12px;
}
</style>
